import React from "react";
import { FaRegCircleXmark } from "react-icons/fa6";

function EmailVerifiedFailed() {
  const closeTab = () => {
    window.close();
  };

  return (
    <div className="bg-[#F9FAFB] py-14 h-screen">
      <div className="h-[30vh] px-10 max-md:px-5">
        <div className="flex justify-center items-center flex-col mx-auto mt-20">
          <div className="flex justify-center items-center flex-col max-w-[730px] border border-gray-200 p-6 rounded-lg bg-white">
            <div className="flex items-center justify-center gap-3 max-md:text-center max-md:flex-col">
              <FaRegCircleXmark className="text-[45px] text-red-400" />
              <div className="flex-1 text-[30px] font-bold text-[#1c3775] max-md:text-[24px]">
                Email verification failed!
              </div>
            </div>
            <div className="mt-4 text-center font-normal max-md:text-sm text-[#374151]">
              Unfortunately, we could not verify your email address. Please try again or contact support for assistance.
            </div>
            <div className="w-full m-auto">
              <button
                onClick={closeTab}
                className="mt-7 w-full m-auto bg-[#1c3775] text-white px-7 py-3 rounded-full font-normal text-lg max-md:text-[14px]"
              >
                Close this tab
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default EmailVerifiedFailed;
